import OrderCustomers from '../OrderCustomers/order-customers';

export default OrderCustomers;